import { LagerauswertungAlleDetails } from "@/components/lagerauswertung/lagerauswertung";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/lagerauswertung/$warehouseId/$date")({
  component: RouteComponent,
});

function RouteComponent() {
  const { date, warehouseId } = Route.useParams();
  const navigate = useNavigate();
  const changeDate = (date: string) => {
    navigate({
      to: "/lagerauswertung/$warehouseId/$date",
      params: { date, warehouseId },
    });
  };
  return (
    <LagerauswertungAlleDetails
      date={date}
      changeDate={changeDate}
      warehouseId={parseInt(warehouseId)}
    />
  );
}
